import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { VISIBILITY_BADGE_TRANSLATION_KEYS } from "./visibilityBadgeTranslationKeys";

type VisibilityBadgeProps = {
    isShared: boolean;
    /** Appended to `visibility-badge-` for repeated rows (table rows, profile lists, etc.). */
    dataAutomationSuffix?: string;
};

export const VisibilityBadge = ({ isShared, dataAutomationSuffix }: VisibilityBadgeProps) => {
    const { translate } = useTranslate();
    const labelKey = isShared ? VISIBILITY_BADGE_TRANSLATION_KEYS.shared : VISIBILITY_BADGE_TRANSLATION_KEYS.private;
    const dataAutomation = dataAutomationSuffix ? `visibility-badge-${dataAutomationSuffix}` : "visibility-badge";

    return (
        <Flex
            inline
            data-automation={dataAutomation}
        >
            <Badge
                bgColor={isShared ? colorsPalettes.carbon["25"] : colorsPalettes.indigo["100"]}
                color={isShared ? colorsPalettes.carbon["400"] : colorsPalettes.indigo["400"]}
                type="custom"
            >
                {translate(labelKey)}
            </Badge>
        </Flex>
    );
};
